import MainAudienceOverlap from '@components/layout/main/AudienceOverlap';
import { generateKey } from '@utils';
import type { Audience } from 'types/schema';
import Styled from './AudienceOverlap.styled';

interface Stat {
  label: string;
  value: string;
}

interface Props {
  audienceData: Audience[];
  stats?: Stat[];
  title?: string;
}

function AudienceOverlap({ audienceData, stats, title }: Props) {
  return (
    <Styled.Root>
      {title ? (
        <Styled.Header>
          <Styled.Title>{title}</Styled.Title>
          <Styled.HeaderDivider />
        </Styled.Header>
      ) : null}
      <Styled.Body>
        <Styled.DiagramSection>
          <MainAudienceOverlap audienceData={audienceData} />
        </Styled.DiagramSection>
        {stats?.length ? (
          <>
            <Styled.VerticalDivider />
            <Styled.StatsSection>
              {stats.map((stat, index) => (
                <Styled.StatGroup
                  key={generateKey(`overlap-stat-${stat.value}-${index}`)}>
                  {index > 0 ? <Styled.StatDivider /> : null}
                  <Styled.Stat>
                    <Styled.StatValue>{stat.value}</Styled.StatValue>
                    <Styled.StatLabel>{stat.label}</Styled.StatLabel>
                  </Styled.Stat>
                </Styled.StatGroup>
              ))}
            </Styled.StatsSection>
          </>
        ) : null}
      </Styled.Body>
    </Styled.Root>
  );
}

export default AudienceOverlap;
